// src/components/AddCompanyForm/utils.js
export const toHex = (v) => {
  if (!v) return "";
  let s = String(v).trim();
  if (s.startsWith("#")) s = s.slice(1);
  if (!/^[0-9a-fA-F]{6}$/.test(s)) return "";
  return `#${s.toUpperCase()}`;
};

export const onlyDigits = (s) => String(s || "").replace(/\D+/g, "");

export const validCep8 = (s) => /^\d{8}$/.test(onlyDigits(s));

export const formatCepInput = (raw) => {
  const d = onlyDigits(raw).slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
};

export const parseCoord = (v) => {
  if (v === "" || v == null) return null;
  const n = Number(String(v).replace(",", ".").trim());
  return Number.isFinite(n) ? n : NaN;
};

export const isHttps = (url) => /^https?:\/\//i.test(String(url || "").trim());

export const slugify = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const uid = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;
